class LoadMoreArticles extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-load-more]');
    this.container = document.querySelector(this.dataset.container);
    this.itemSelector = this.dataset.itemSelector;
    this.currentPage = parseInt(this.dataset.currentPage, 10);
    this.totalPages = parseInt(this.dataset.totalPages, 10);
    this.loading = false;

    if (this.button) {
      this.button.addEventListener('click', this.onClick.bind(this));
    }
  }

  async onClick(event) {
    event.preventDefault();
    if (this.loading) return;

    const nextUrl = this.button.getAttribute('href');
    if (!nextUrl) return;

    this.loading = true;
    this.button.setAttribute('aria-busy', 'true');
    this.button.classList.add('is-loading');

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      // Grab new articles from the fetched page
      const newContainer = doc.querySelector(this.dataset.container);
      const newItems = newContainer ? newContainer.querySelectorAll(this.itemSelector) : [];

      newItems.forEach((item) => {
        this.container.appendChild(item);
      });

      // Advance page state
      this.currentPage += 1;

      // Update the address bar so the URL is shareable/back-button friendly
      history.replaceState({}, '', nextUrl);

      // Point the button at the following page, or remove it when done
      const nextButton = doc.querySelector('[data-load-more]');
      if (nextButton && this.currentPage < this.totalPages) {
        this.button.setAttribute('href', nextButton.getAttribute('href'));
      } else {
        this.button.remove();
      }
    } catch (err) {
      console.error('Load more failed:', err);
      // Fall back to normal navigation on failure
      window.location.href = nextUrl;
    } finally {
      this.loading = false;
      if (this.button) {
        this.button.removeAttribute('aria-busy');
        this.button.classList.remove('is-loading');
      }
    }
  }
}

customElements.define('load-more-articles', LoadMoreArticles);
